import Search from './search';
import {Tabs} from './tabs';

class AnalyticsGlossary {
    init() {
        const analyticsGlossary = document.querySelector('.analytics-glossary');

        if (!analyticsGlossary) return

        this.tabs = new AnalyticsTabs(analyticsGlossary);
    }
}

// ..........ANALYTICS GLOSSARY FILTER BUTTONS

class AnalyticsTabs extends Tabs {
    constructor(container) {
        super(container)

        this.search = new AnalyticsSearch(container);
    }

    showContent(btnValue) {
        this.content.forEach(content => {
            const key = content.dataset.key.toLowerCase();

            if (btnValue == key) {
                this.hideNotMatched();
                this.hideIsEvery(content);
            } else {
                content.classList.add('hidden');
            }

        })
    }

    hideIsEvery(content) {
        const searchItems = [...content.querySelectorAll('.search-parent')];
        const is_contain = searchItems.every(parent => parent.classList.contains('hidden'));

        if (!is_contain) this.remove(content);
    }

    hideNotMatched() {
        const search = this.search;
        const value = search.field.value.toLowerCase();

        search.items.forEach(parent => {
            const searchItem = parent.querySelector('.search-item').textContent.toLowerCase();
            const wrapper = parent.closest('.searchable-table').parentNode;
            
            if (searchItem.indexOf(value) > -1) {
                this.remove(wrapper);
                this.remove(parent)
            }
        });
    }

    remove(elem) {
        elem.classList.remove('hidden');
    }
}

// ..........ANALYTICS GLOSSARY SEARCH

class AnalyticsSearch extends Search {
    constructor(container) {
        super(container)

        this.items = this.container.querySelectorAll('.content tr.search-parent');
        this.tables = this.container.querySelectorAll('.searchable-table');

        this.filterBtn;

        this.init();
    }

    inputHandler() {
        this.field.addEventListener('input', () => {
            this.hideAllElements();
            this.initSearch();
        })
    }

    initSearch() {
        this.search();
        this.hideNotMatched();
    }

    search() {
        const value = this.field.value.toLowerCase();

        this.items.forEach(item => {
            const searchItem = item.querySelector('.search-item').textContent.toLowerCase();
            const searchCode = item.querySelector('.search-code').textContent.toLowerCase();

            this.detectFilters();

            const filterSelector = item.closest(`[data-key=${this.filterBtn}]`);

            if ((searchItem.indexOf(value) > -1 || searchCode.indexOf(value) > -1) && filterSelector) {
                this.show(item);
            }
        });
    }

    show(elem) {
        elem.classList.remove('hidden');
    }

    detectFilters() {
        const filterButton = this.container.querySelector('.filter-button.active');
        const getButtonText = filterButton.textContent.toLowerCase();

        this.filterBtn = getButtonText;
    }

    hideNotMatched() {
        this.tables.forEach(table => {
            const searchParents = [...table.querySelectorAll('.search-parent')];
            this.checkClassForAll(table, searchParents);
        })
    }

    checkClassForAll(table, array) {
        const is_contain = array.every(parent => parent.classList.contains('hidden'))

        if (is_contain) {
            table.parentNode.classList.add('hidden');
        } else {
            table.parentNode.classList.remove('hidden');
        }
    }
}

export default new AnalyticsGlossary();
